<template>
    <div class="wa-status">
        <SOSlotBase :bg-grey="true" :loading="!formready">
            <template v-slot:title-bar>
                <SOTitleBar :type="'back'" :page-title="'Status WA Aktif'" @back="back" />
            </template>
            <template v-slot:loading-page>
                <div>
                    <SOLoadingPage />
                </div>
            </template>
            <template v-slot:content v-if="formready">
                <div class="position-relative">
                    <div class="position-fixed w-100 z-99">
                        <DeviceInfo :name="getDeviceName" :number="getDeviceNumber" />
                    </div>
                    <div class="p-x-20 p-t-20">
                        <div class="card_breadcrum p-t-16">
                            <SOHeaderList :title="`Postingan aktif`" :show-filter="true" @filter="togleFilter(true)" />
                        </div>
                        <div>
                            <CardStatusWA :data-list="storyAktif" :data-count="storyAktifTotal"/>
                        </div>
                    </div>
                    <SOLoadMoreLoading :id="'load-more-status-aktif'" :loading="isLoadMore" />
                    <SOFABRegular @add="gotoAddForm" />
                </div>
            </template>
            <template v-slot:filter>
                <SOFilter
                    v-if="onFilter"
                    filter-wa-status="aktif"
                    :sorting="getSorting"
                    @back="togleFilter(false)"
                    @do-filter="doFilter"
                    @reset-filter="resetFilter"
                />
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import SOFABRegular from "@/so-components/global/ui/SOFABRegular";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";

import SOFilter from "@/so-components/global/filter/base/SOFilter";

import DeviceInfo from "../components/DeviceInfo.vue";
import CardStatusWA from "../components/CardStatusWA.vue";

import sorting from "../static/sortOrder";
import { moduleName } from "../store/state";

const skipLastItem = [
    "wa_status.status_aktif.diposting",
    "wa_status.status_aktif.terjadwal",
    "wa_status.status_aktif.sedang_tayang",
    "wa_status.status_aktif.gagal_posting",
];

export default {
    name: "WaStatusAktif",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOLoadingPage,
        SOFABRegular,
        SOHeaderList,
        SOLoadMoreLoading,
        SOFilter,
        DeviceInfo,
        CardStatusWA,
    },
    data() {
        return {
            formready: false,
            onFilter: false,
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (skipLastItem.indexOf(from.name) !== -1) {
                vm.scrollTo();
            }
        });
    },
    mounted() {
        this.init();
        this.scrollTo();
    },
    beforeRouteLeave(to, from, next) {
        if (skipLastItem.indexOf(from.name) === -1) {
            if (to.name !== "dashboard") {
                this.setLastItem();
            }
        }
        next();
    },
    watch: {
        storyAktif: function(newSt, oldSt) {
            if (oldSt.length === 0 && newSt.length > 0) {
                this.setFormready(true);
            }
        },
        response: function(newRes, oldRes) {
            if (newRes.data === "wa_status") {
                if (newRes.success) {
                    this.$toast.success(newRes.msg);
                } else {
                    this.$toast.error(newRes.err);
                }
            }
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            storyAktif: "storyAktif",
            storyAktifTotal: "storyAktifTotal",
            endStoryAktif: "endStoryAktif",
            showStoryAktif: "showStoryAktif",
            dataDeviceTiny: "dataDeviceTiny",
            deviceid: "deviceid",
            isFetching: "isFetching",
            isLoadMore: "isLoadMore",
            response: "response",
        }),
        getAktifId() {
            return this.$route.params.aktif_id ? this.$route.params.aktif_id : "";
        },
        getDeviceName() {
            return this.dataDeviceTiny.nama ? this.dataDeviceTiny.nama : "Semua Perangkat";
        },
        getDeviceNumber() {
            return this.dataDeviceTiny.number ? this.dataDeviceTiny.number : "";
        },
        getSorting() {
            return sorting;
        },
    },
    methods: {
        ...mapActions({
            getStoryAktif: `${moduleName}/getStoryAktif`,
            setFileUpload: `${moduleName}/setFileUpload`,
            setEndStoryAktif: `${moduleName}/setEndStoryAktif`,
            resetPage: `${moduleName}/resetPage`,
            resetList: `${moduleName}/resetList`,
        }),
        init() {
            if (this.storyAktif.length === 0) {
                this.getStoryAktif({ iddevice: this.getAktifId });
            } else {
                this.setFormready(true);
            }
        },
        setFormready(val) {
            this.formready = val;
        },
        back() {
            this.$router.go(-1);
        },
        dataReset(target) {
            this.resetPage({ target });
            this.resetList({ target });
        },
        gotoAddForm() {
            this.$router.push({ name: "wa_status.create_status" });
            this.setFileUpload("");
        },
        togleFilter(val) {
            this.onFilter = val;
        },
        async doFilter() {
            await this.dataReset("storyAktif");
            await this.togleFilter(false);
            await this.getStoryAktif({ iddevice: this.getAktifId });
        },
        async resetFilter() {
            await this.$store.commit("filterGlobalModule/resetFilterItem");
            await this.$store.commit("filterGlobalModule/setFilter", JSON.parse(this.getSorting[0].value));
        },
        scrollTo() {
            let el = document.getElementById(this.endStoryAktif.id);
            if (el) {
                setTimeout(() => {
                    el.scrollIntoView();
                    document.documentElement.scrollTop = document.documentElement.scrollTop - 53;
                }, 100);
            }
        },
        setLastItem() {
            let newDP = this.showStoryAktif.sort(function(a, b) {
                if (a.yDir < b.yDir) {
                    return -1;
                }
                if (a.yDir > b.yDir) {
                    return 1;
                }
                return 0;
            });

            if (newDP[0]) {
                this.setEndStoryAktif(newDP[0]);
            }
        },
    },
};
</script>
